import { SCORE_COLORS } from "../constants/colors";

/** 점수 구간 경계 (backend analyzer/config.py GRADES와 정렬: 75/60/45/30) */
export const SCORE_THRESHOLDS = {
  strongBuy: 75,
  buy: 60,
  hold: 45,
  underperform: 30,
} as const;

/** 점수 → Tailwind 텍스트 색 클래스 (4단계) */
export function getScoreColorClass(score: number): string {
  if (score >= SCORE_THRESHOLDS.strongBuy) return "text-green-500";
  if (score >= SCORE_THRESHOLDS.buy) return "text-indigo-500";
  if (score >= SCORE_THRESHOLDS.hold) return "text-amber-500";
  return "text-red-500";
}

/** 점수 → hex 색 (4단계) */
export function getScoreColorHex(score: number): string {
  if (score >= SCORE_THRESHOLDS.strongBuy) return SCORE_COLORS.strongBuy;
  if (score >= SCORE_THRESHOLDS.buy) return SCORE_COLORS.buy;
  if (score >= SCORE_THRESHOLDS.hold) return SCORE_COLORS.hold;
  return SCORE_COLORS.sell;
}

/**
 * 점수 → score-fill CSS 클래스 (3단계: high/mid/low).
 * CSS(App.css)에 high=green/mid=amber/low=red만 정의됨.
 * high 경계를 75로 통일(기존 ScoreBar는 70이었음 — Cycle 52에서 정렬).
 */
export function getScoreFillClass(score: number): string {
  if (score >= SCORE_THRESHOLDS.strongBuy) return "score-fill-high";
  if (score >= SCORE_THRESHOLDS.hold) return "score-fill-mid";
  return "score-fill-low";
}
